export const rangeFacetSortCriteria = [
    'ascending',
    'descending',
];
/**
 * Whether the range algorithm proposes ranges based on an even split of the interval or equiprobable intervals that each contain the same amount of results.
 */
export const rangeFacetRangeAlgorithm = [
    'even',
    'equiprobable',
];
